var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"iconfont iconicon_copy copy-icon",on:{"click":function($event){return _vm.copyText()}}})}
var staticRenderFns = []

export { render, staticRenderFns }